/* --------------- swiper --------------- */
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.page-501stories .swiper-row').forEach((slide) => {
    const columnSwiper = new Swiper(slide, {
      loop: true,
      loopAdditionalSlides: 1,
      speed: 500,
      navigation: {
        nextEl: slide.querySelector('.swiper-button-next'),
        prevEl: slide.querySelector('.swiper-button-prev'),
      },
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  });

  const elmThumb = document.querySelector('.swiper-thumb');
  let thumbOption = {
    navigation: {
      nextEl: elmThumb.querySelector('.swiper-button-next'),
      prevEl: elmThumb.querySelector('.swiper-button-prev'),
    },
  };

  const updateThumbOptions = (option) => {
    if (window.innerWidth < 750) {
      option.centeredSlides = true;
      option.loop = true;
      option.loopAdditionalSlides = 1;
      option.initialSlide = 4;
      option.speed = 500;
      option.slidesPerView = 1.35;
      option.spaceBetween = 5;
    } else {
      option.centeredSlides = false;
      option.loop = false;
      option.slidesPerView = 5;
      option.spaceBetween = 20;
      option.breakpoints = {
        750: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      };
    }
  };

  updateThumbOptions(thumbOption);
  
  const videoThumb = new Swiper(elmThumb, thumbOption);
  const videoMain = new Swiper('.swiper-video', {
    effect: 'fade',
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 5,
    thumbs: {
      swiper: videoThumb,
    },
  });

  window.matchMedia('(min-width: 750px)').addEventListener('change', (e) => {
    updateThumbOptions(videoThumb.params);
    videoThumb.update();
  });
});

/* --------------- modal --------------- */
function modalOpen(e) {
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  var target = e.currentTarget.dataset.target;
  var modal = document.getElementById(target);
  var cover = document.querySelector('.modal-cover');
  modal.classList.toggle('is-open');
  modal.classList.toggle('is-close');
  cover.classList.toggle('is-open');
  cover.classList.toggle('is-close');
  document.querySelector('body').dataset.top = scrollTop;
  document.querySelector('body').classList.add('is-fixed');
  document.querySelector('body').style.top = -scrollTop + 'px';
}

function modalClose() {
  var scrollPos = document.querySelector('body').dataset.top;
  for (var i = 0; i < document.querySelectorAll('.js-modal').length; i++) {
    if (document.querySelectorAll('.js-modal')[i].classList.contains('is-open')) {
      document.querySelectorAll('.js-modal')[i].classList.add('is-close');
    }
    document.querySelectorAll('.js-modal')[i].classList.remove('is-open');
    document.querySelector('.modal-cover').classList.remove('is-open');
    document.querySelector('.modal-cover').classList.add('is-close');
    document.querySelector('body').classList.remove('is-fixed');
    document.querySelector('body').style.top = '';
    window.scrollTo(0, scrollPos);
  }
}

function modalEvent() {
  var openBtn = document.querySelectorAll('.js-modal-open');
  Array.prototype.forEach.call(openBtn, function (modalOpenElement) {
    modalOpenElement.addEventListener('click', modalOpen);
  });
  var closeBtn = document.querySelectorAll('.js-modal-close');
  Array.prototype.forEach.call(closeBtn, function (modalCloseElement) {
    modalCloseElement.addEventListener('click', modalClose);
  });
}
/* --------------- tabs --------------- */

document.addEventListener('DOMContentLoaded', function () {
  modalEvent();
  document.querySelectorAll('.swiper-video .video__btn--play').forEach((btn) => {
    btn.addEventListener('click', () => {
      const elm = btn.closest('.video__wrap');
      elm.querySelector('.video__item')?.remove();
    });
  });
});
